import { API, Endpoints, Tag } from "@brg/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const useGetPersonalizedTag = (accountId: string) => {
    const { t, i18n } = useTranslation();
    const [personalizedTags, setPersonalizedTags] = useState<Tag[]>([]);
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const fetchPersonalizedTag = async () => {
        if (!accountId) return;

        try {
            setIsFetching(true);
            setError(null);
            const request = await API.request()
            .endpoint(Endpoints.tagsMnePw)
            .url('/api/Tags/GetPersonalizedTag')
            .addQuery('accountId', accountId)
            .get()
            .send()
            .then(response => response.json())

            const localized = request ? API.toLang(request, i18n.language) : [];
            const tags = Array.isArray(localized) ? localized : localized ? [localized] : [];
            setPersonalizedTags(tags);
        } catch (error) {
            setError(error as Error);
        } finally {
            setIsFetching(false);
        }
    }

    useEffect(() => {
        fetchPersonalizedTag();
    }, [accountId])

    return {
        personalizedTags,
        isFetching,
        error
    }
}import { API, Endpoints, Tag } from "@brg/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const useGetPersonalizedTag = (accountId: string) => {
    const { t, i18n } = useTranslation();
    const [personalizedTags, setPersonalizedTags] = useState<Tag[]>([]);
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const fetchPersonalizedTag = async () => {
        if (!accountId) return;

        try {
            setIsFetching(true);
            setError(null);
            const request = await API.request()
            .endpoint(Endpoints.tagsMnePw)
            .url('/api/Tags/GetPersonalizedTag')
            .addQuery('accountId', accountId)
            .get()
            .send()
            .then(response => response.json())

            const localized = request ? API.toLang(request, i18n.language) : [];
            const tags = Array.isArray(localized) ? localized : localized ? [localized] : [];
            setPersonalizedTags(tags);
        } catch (error) {
            setError(error as Error);
        } finally {
            setIsFetching(false);
        }
    }

    useEffect(() => {
        fetchPersonalizedTag();
    }, [accountId])

    return {
        personalizedTags,
        isFetching,
        error
    }
}